import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-social-security-info',
  templateUrl: './text-social-security-info.component.html',
  styleUrls: ['./text-social-security-info.component.css'],
})
export class TextSocialSecurityInfoComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit() {
  }

}
